// @flow
import { Record, OrderedMap } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

type NotificationType = {
  id: string,
  snackbarContent: any,
  snackbarContentProps: any,
  autoHideDuration: ?number,
};
export type Notification = RecordOf<NotificationType>;
export const mkNotification: RecordFactory<NotificationType> = Record({
  id: undefined,
  snackbarContent: undefined,
  snackbarContentProps: undefined,
  autoHideDuration: undefined,
});

type NotificationsStoreType = {
  notifications: ?OrderedMap<string, Notification>,
};
export type NotificationsStore = RecordOf<NotificationsStoreType>;
export const mkNotificationsStore: RecordFactory<NotificationsStoreType> = Record({
  notifications: OrderedMap(),
});
